
export const PermissionsSize = 250;

export const PPAPermissions = {

    // Report requests
    ViewAllReportRequests: 0,
    ViewMyReportRequests: 1,

    // View storage report group
    ViewStorageReportGroup: 2,

    // Storage in tenant report
    RequestStorageInTenantReport: 3,
    ViewAllStorageInTenantReports: 4,
    ViewMyStorageInTenantReports: 5,

    // Storage in workspace report
    RequestStorageInWorkspaceReportMineOnly: 6,
    RequestStorageInWorkspaceReportAny: 7,
    ViewAllStorageInWorkspaceReports: 8,
    ViewMyStorageInWorkspaceReports: 9,

    // Storage in workspaces by owner report
    RequestStorageInWorkspacesByOwnerReportMineOnly: 10,
    RequestStorageInWorkspacesByOwnerReportAny: 11,
    ViewAllStorageInWorkspacesByOwnerReports: 12,
    ViewMyStorageInWorkspacesByOwnerReports: 13,

    // View guest users report group
    ViewGuestUsersReportGroup: 14,

    // Guest users in tenant report
    RequestGuestUsersInTenantReport: 15,
    ViewAllGuestUsersInTenantReports: 16,
    ViewMyGuestUsersInTenantReports: 17,

    // Guest user report
    RequestGuestUserReport: 18,
    ViewAllGuestUserReports: 19,
    ViewMyGuestUserReports: 20,

    // Guest users in workspaces by owner report
    RequestGuestUsersInWorkspacesByOwnerReportMineOnly: 21,
    RequestGuestUsersInWorkspacesByOwnerReportAny: 22,
    ViewAllGuestUsersInWorkspacesByOwnerReports: 23,
    ViewMyGuestUsersInWorkspacesByOwnerReports: 24,

    // Guest users in workspace report
    RequestGuestUsersInWorkspaceReportMineOnly: 25,
    RequestGuestUsersInWorkspaceReportAny: 26,
    ViewAllGuestUsersInWorkspaceReports: 27,
    ViewMyGuestUsersInWorkspaceReports: 28,

    // View sharing links report group
    ViewSharingLinksReportGroup: 29,

    // Sharing links in tenant report
    RequestSharingLinksInTenantReport: 30,
    ViewAllSharingLinksInTenantReports: 31,
    ViewMySharingLinksInTenantReports: 32,

    // Sharing links in workspaces by owner report
    RequestSharingLinksInWorkspacesByOwnerReportMineOnly: 33,
    RequestSharingLinksInWorkspacesByOwnerReportAny: 34,
    ViewAllSharingLinksInWorkspacesByOwnerReports: 35,
    ViewMySharingLinksInWorkspacesByOwnerReports: 36,

    // Sharing links in workspace report
    RequestSharingLinksInWorkspaceReportMineOnly: 37,
    RequestSharingLinksInWorkspaceReportAny: 38,
    ViewAllSharingLinksInWorkspaceReports: 39,
    ViewMySharingLinksInWorkspaceReports: 40,

    // View orphaned objects report group
    ViewOrphanedObjectsReportGroup: 41,

    // Orphaned users in tenant report
    RequestOrphanedUsersInTenantReport: 42,
    ViewAllOrphanedUsersInTenantReports: 43,
    ViewMyOrphanedUsersInTenantReports: 44,

    // Orphaned mailboxes in tenant report
    RequestOrphanedMailboxesInTenantReport: 45,
    ViewAllOrphanedMailboxesInTenantReports: 46,
    ViewMyOrphanedMailboxesInTenantReports: 47,

    // Sharing links in OneDrive report
    RequestSharingLinksInOneDriveReportMineOnly: 48,
    RequestSharingLinksInOneDriveReportAny: 49,
    ViewAllSharingLinksInOneDriveReports: 50,
    ViewMySharingLinksInOneDriveReports: 51,

    // Storage in OneDrive report
    RequestStorageInOneDriveReportMineOnly: 52,
    RequestStorageInOneDriveReportAny: 53,
    ViewAllStorageInOneDriveReports: 54,
    ViewMyStorageInOneDriveReports: 55,

    // Orphaned workspaces in tenant report
    RequestOrphanedWorkspacesInTenantReport: 56,
    ViewAllOrphanedWorkspacesInTenantReports: 57,
    ViewMyOrphanedWorkspacesInTenantReports: 58,

    // View usage reports group
    ViewUsageReportsGroup: 59,

    // Inactive workspaces in tenant report
    RequestInactiveWorkspacesInTenantReport: 60,
    ViewAllInactiveWorkspacesInTenantReports: 61,
    ViewMyInactiveWorkspacesInTenantReports: 62,

    // Inactive workspaces by owner report
    RequestInactiveWorkspacesByOwnerReportMineOnly: 63,
    RequestInactiveWorkspacesByOwnerReportAny: 64,
    ViewAllInactiveWorkspacesByOwnerReports: 65,
    ViewMyInactiveWorkspacesByOwnerReports: 66,

    // View summary reports group
    ViewSummaryReportsGroup: 67,

    // Workspace summary in tenant report
    RequestWorkspaceSummaryInTenantReport: 68,
    ViewAllWorkspaceSummaryInTenantReports: 69,
    ViewMyWorkspaceSummaryInTenantReports: 70,

    // Workspace summary by owner report
    RequestWorkspaceSummaryByOwnerReportMineOnly: 71,
    RequestWorkspaceSummaryByOwnerReportAny: 72,
    ViewAllWorkspaceSummaryByOwnerReports: 73,
    ViewMyWorkspaceSummaryByOwnerReports: 74,

    // View file size reports group
    ViewFileSizeReportsGroup: 75,

    // File size in tenant report
    RequestFileSizeInTenantReport: 76,
    ViewAllFileSizeInTenantReports: 77,
    ViewMyFileSizeInTenantReports: 78,

    // Action requests
    ViewAllActionRequests: 100,
    ViewMyActionRequests: 101,

    // View orphaned objects action group
    ViewOrphanedObjectsActionGroup: 102,

    // Remove orphaned users action
    RequestRemoveOrphanedUsersAction: 103,
    ViewAllRemoveOrphanedUsersActions: 104,
    ViewMyRemoveOrphanedUsersActions: 105,

    // View guest users action group
    ViewGuestUsersActionGroup: 106,

    // Remove guest users action
    RequestRemoveGuestUsersAction: 107,
    ViewAllRemoveGuestUsersActions: 108,
    ViewMyRemoveGuestUsersActions: 109,

    // View sharing links action group
    ViewSharingLinksActionGroup: 110,

    // Remove sharing links action
    RequestRemoveSharingLinksAction: 111,
    ViewAllRemoveSharingLinksActions: 112,
    ViewMyRemoveSharingLinksActions: 113,

    // View settings
    ViewSettings: 200,

    // View permission settings
    ViewPermissionSettings: 201,

    // Application roles
    ViewApplicationRoles: 202,
    AddApplicationRole: 203,
    UpdateApplicationRole: 204,
    DeleteApplicationRole: 205,
    UpdateApplicationRoleMembership: 206,

    // Application role assignments (NOT YET USED)
    ViewApplicationRoleAssignments: 207,

    // Microsoft Entra ID application permission
    ViewMicrosoftEntraIDPermissions: 210,
    ConsentMicrosoftEntraIDPermissions: 211
}

export type PPAPermission = typeof PPAPermissions[keyof typeof PPAPermissions]